import React, { useEffect } from "react";
import { useHistory } from "react-router";
import { Button, Table } from "antd";
import { goPage } from "../../layout/pageDefinition";
import { useModel } from "../../../models";
import { YhAuth } from "../../../components/Auth";
import { ResourceAuthEnum } from "../../../utils/resourcesAuth";

const columns = [
    {
        title: '序号',
        width: 50,
        render: (text, record, index) => `${index + 1}`,
    },
    {
        title: '销售单号',
        width: 160,
        dataIndex: 'saleCode',
        align: 'left',
        render: (text, record, index) => { return record.isReplenish ? (<span className="color-red">{text}</span>) : text },
    },
    {
        title: '转接单号',
        width: 160,
        dataIndex: 'saleOrderCode',
        align: 'left',
    },
    {
        title: '销售类型',
        width: 120,
        dataIndex: 'orderTypeName',
    },
    {
        title: '状态',
        width: 120,
        dataIndex: 'orderStatusName',
    },
    {
        title: '支付状态',
        width: 120,
        dataIndex: 'paymentStatusName',
    },
    {
        title: '客户名称',
        width: 160,
        ellipsis: true,
        dataIndex: 'customerName',
    },
    {
        title: '销售数量',
        width: 100,
        dataIndex: 'saleNum',
    },
    {
        title: '退货数量',
        width: 100,
        dataIndex: 'returnNum',
    },
    {
        title: '未出库数量',
        width: 100,
        dataIndex: 'noIssuedNum',

    },
    {
        title: '优惠总金额',
        width: 100,
        dataIndex: 'discountAmount',
    },
    {
        title: '应收金额',
        width: 100,
        dataIndex: 'receivableAmount',

    },
    {
        title: '已收金额',
        width: 100,
        dataIndex: 'paidAmount',

    },
    {
        title: '销售成本',
        width: 100,
        dataIndex: 'saleCost',
    },
    {
        title: '销售毛利',
        width: 100,
        dataIndex: 'saleProfit',

    },

    {
        title: '发票类型',
        width: 120,
        dataIndex: 'invoiceTypeName',
    },
    {
        title: '客户编码',
        width: 160,
        dataIndex: 'customerCode',
    },

    {
        title: '联系人',
        width: 120,
        dataIndex: 'customerPerson',
    },
    {
        title: '电话',
        width: 120,
        dataIndex: 'customerPhone',
    },
    {
        title: '业务员',
        width: 100,
        dataIndex: 'createUser',
    },
    /*{
        title: '公司',
        width: 160,
        ellipsis: true,
        dataIndex: 'orgName',
    },*/
    {
        title: '制单日期',
        width: 160,
        dataIndex: 'createTime',
    },
    {
        title: '备注',
        width: 200,
        dataIndex: 'saleDesc',
    }
];


export default function () {
    const [
        {
            searchParam,
            documentList,
            documentStatistic,
            documentPageInfo,
            selectedDocumentRowKeys
        },
        {
            loadDocumentList,
            exportSo,
            setSelectedDocumentRowKeys,
            setDocumentMaterialList,
            loadSo,
            setSelectedDocument,
            setFormData
        }
    ] = useModel("saleSo");
    // const {pageSize, pageNum} = documentPageInfo;
    useEffect(() => {
        const [startTime = null, endTime = null] = !!searchParam["startEndDate"] ? searchParam["startEndDate"] : [];

        const { saleCode, customerId, orderStatus, invoiceType } = searchParam;
        let data = {
            pageSize: 100,
            pageNum: 1,
            startTime,
            endTime,
            saleCode,
            customerId,
            orderStatus: orderStatus ? orderStatus.toString() : "",
            invoiceType
        };
        loadDocumentList({ showMsg: false, data });
    }, []);
    const TableHeader = () => {
        const history = useHistory();
        const onAdd = () => {
            setSelectedDocument({});
            setDocumentMaterialList([]);
            setFormData({});
            goPage(history, "3-2-2");
        }
        const onEdit = () => {
            setFormData({});
            loadSo({ showMsg: false, data: selectedDocumentRowKeys[0] }).then(() => {
                goPage(history, "3-2-1");
            });
        }

        const onExport = () => {
            const { saleCode, customerId, orderStatus, invoiceType, startEndDate } = searchParam;
            const [startTime = null, endTime = null] = !!startEndDate ? startEndDate : [];
            const { pageSize, pageNum } = documentPageInfo;
            let data = {
                pageSize,
                pageNum,
                startTime,
                endTime,
                saleCode,
                customerId,
                orderStatus,
                invoiceType
            };
            exportSo({ showMsg: true, data });
        }

        return (
            <div style={{ margin: "0 0 8px", display: "flex" }}>
                <div style={{ width: "460px", paddingTop: "6px" }}>
                    <YhAuth resCode={ResourceAuthEnum.S_AD}>
                        <Button type="primary" onClick={onAdd}>新增</Button>
                    </YhAuth>
                    <YhAuth resCode={ResourceAuthEnum.S_ED}>
                        <Button
                            className="margin-left-8"
                            onClick={onEdit}
                            disabled={!(selectedDocumentRowKeys.length > 0)}
                        >
                            {
                                (
                                    selectedDocumentRowKeys.length === 1
                                    && documentList.find(el => el.key === selectedDocumentRowKeys[0])
                                    && documentList.find(el => el.key === selectedDocumentRowKeys[0]).orderStatus === "017005"
                                ) ? "查看" : "编辑"
                            }
                        </Button>
                    </YhAuth>
                    <YhAuth resCode={ResourceAuthEnum.S_EXPORT}>
                        <Button className="margin-left-8" onClick={onExport}>导出</Button>
                    </YhAuth>
                </div>
                <div className="detail-list-statistic color-primary" style={{ textAlign: "right" }}>
                    {/*<span
                        className="margin-left-8">
                        销售毛利：{!!documentStatistic ? documentStatistic.grossProfit : 0}
                    </span>
                    <span
                        className="margin-left-16">
                        销售成本：{!!documentStatistic ? documentStatistic.productionCost : 0.00}
                    </span>
                    <span
                        className="margin-left-16">
                        销售总金额：{!!documentStatistic ? documentStatistic.aggregateAmountTotal : 0.00}
                    </span>*/}
                    <span
                        className="margin-left-8">
                        销售数量：{!!documentStatistic ? documentStatistic.purchaseQuantityTotal : 0}
                    </span>
                    <span
                        className="margin-left-16">
                        应收金额：{!!documentStatistic ? documentStatistic.amountPayableTotal : 0.00}
                    </span>
                    <span
                        className="margin-left-16">
                        已收金额：{!!documentStatistic ? documentStatistic.amountPaidTotal : 0.00}
                    </span>
                    <span
                        className="margin-left-16">
                        成本总计：{!!documentStatistic ? documentStatistic.saleCostTotal : 0.00}
                    </span>
                    <span
                        className="margin-left-16">
                        毛利总计：{!!documentStatistic ? documentStatistic.saleProfitTotal : 0.00}
                    </span>
                </div>
            </div>
        )
    }

    return (
        <>
            <TableHeader />
            <Table
                columns={columns}
                dataSource={documentList}
                bordered
                pagination={{
                    hideOnSinglePage: false,
                    showSizeChanger: true,
                    pageSizeOptions: [15, 50, 100, 200, 500],
                    defaultCurrent: 1,
                    defaultPageSize: 100,
                    onChange: (pageNum, pageSize) => {
                        const { saleCode, customerId, orderStatus, invoiceType, startEndDate } = searchParam;
                        const [startTime = null, endTime = null] = !!startEndDate ? startEndDate : [];
                        let data = {
                            pageSize,
                            pageNum,
                            startTime,
                            endTime,
                            saleCode,
                            customerId,
                            orderStatus,
                            invoiceType
                        };
                        loadDocumentList({ showMsg: false, data });
                    },
                    total: documentPageInfo.total,
                    current: documentPageInfo.pageNum,

                }}
                onRow={record => {
                    return {
                        onClick: event => {
                            if (selectedDocumentRowKeys.length > 0 && selectedDocumentRowKeys[0] === record.key) {
                                setSelectedDocumentRowKeys([]);
                            } else {
                                setSelectedDocumentRowKeys([record.key]);
                            }
                        },
                    };
                }}
                rowSelection={{
                    type: "radio",
                    onChange: (selectedRowKeys) => {
                        setSelectedDocumentRowKeys(selectedRowKeys);
                    },
                    selectedRowKeys: selectedDocumentRowKeys
                }}
                scroll={{ x: 'max-content', y: 560 }}
            />
        </>
    );
}